class HpQuickShopDrawer extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );

        this.querySelectorAll('button[type="button"]').forEach(button => {
            button.addEventListener(
                'click',
                this.close.bind(this)
            );
        });

        if (window.screen.width >= 1024 && (window.screen.width / window.screen.height > 1)) {
            this.querySelector('.quickshop-backdrop').addEventListener(
                'click',
                this.close.bind(this)
            )
        }

        this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open')
            ? this.close()
            : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
        this.onBodyClickEvent =
            this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        event.target.closest('quick-shop-drawer').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        $(document).trigger('quick-shop:open')
    }

    close() {
        this.detailsContainer.removeAttribute('open');
        this.detailsContainer.closest('quick-shop-drawer').removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        $(document).trigger('quick-shop:close')
    }
}

customElements.define('quick-shop-drawer', HpQuickShopDrawer);
